export default "__VITE_ASSET__CHeVJJ4e__"